const messages = {
  "permission-denied": "You do not have permission to make this change. Contact your property administrator.",
  unauthenticated: "Your session has expired. Sign in again to continue.",
  unavailable: "The service is temporarily unavailable. Your changes have not been confirmed; please try again.",
  "deadline-exceeded": "The request took too long. Check whether it completed before trying again.",
  "resource-exhausted": "Too many requests were made. Please wait a moment and try again.",
  "auth/network-request-failed": "We could not connect. Check your internet connection and try again.",
  "auth/too-many-requests": "Too many sign-in attempts. Please wait a few minutes and try again.",
};

export function userFacingError(error, fallback = "The change could not be saved. Please try again.") {
  const raw = String(error?.code || "");
  const code = raw.replace(/^(firestore|functions)\//, "");
  return messages[raw] || messages[code] || fallback;
}
